import { Bell } from 'lucide-react';
import { useState, useEffect } from 'react';
import { fetchAIAlerts } from '../services/aiService';
import axios from 'axios';

export default function AIAlertBell() {
  const [alerts, setAlerts] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    fetchAIAlerts().then((data) => {
      console.log("[ALERTS FETCHED]", data);
      setAlerts(data);
    });
  }, []);

  const marcarComoVisualizado = async (alerta) => {
    try {
      await axios.post('https://sense-agro-backend.onrender.com/api/alerta-visualizado', {
        id: alerta.id
      });
  
      setAlerts(prev =>
        prev.filter((a) => a.id !== alerta.id)
      );
    } catch (error) {
      console.error('Erro ao marcar alerta como visualizado:', error);
    }
  };
  

  return (
    <div className="relative">
      <button
        className="relative"
        onClick={() => setOpen(!open)}
        title="Alertas da IA"
      >
        <Bell className="w-6 h-6 text-red-600" />
        {alerts.length > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full px-1">
            {alerts.length}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-white border rounded-xl shadow-lg z-20">
          <ul className="p-3 max-h-64 overflow-y-auto">
            {alerts.length > 0 ? (
              alerts.map((alert, index) => (
                <li
                  key={index}
                  className="text-sm border-b py-2 cursor-pointer hover:bg-gray-100"
                  onClick={() => marcarComoVisualizado(alert)}
                >
                  <p className="font-bold">{alert.title}</p>
                  <p className="text-gray-600">{alert.message}</p>
                </li>
              ))
            ) : (
              <p className="text-sm text-gray-500 text-center">Sem alertas pendentes.</p>
            )}
          </ul>
        </div>
      )}
    </div>
  );
}
